module.exports = __webpack_public_path__ + "static/media/milestone_wave.ddd76b00.png";